import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ArtTreatmentDefinition, ArtTreatmentIntegrity, ArtTreatmentIndication } from '@modules/rx-intuitive-art/models';

@Pipe({
	name: 'artTreatmentTranslate',
	standalone: true,
	pure: false
})
export class ArtTreatmentTranslatePipe extends TranslatePipe implements PipeTransform {
	constructor(translate: TranslateService, ref: ChangeDetectorRef) {
		super(translate, ref);
	}

	override transform(value: ArtTreatmentIndication | string | number | null | undefined, ...args: any[]): any {
		if (value === undefined || value === null || typeof value === 'string') {
			return '';
		}

		const name = ArtTreatmentIntegrity[value as ArtTreatmentIntegrity] ?? ArtTreatmentDefinition[value as ArtTreatmentDefinition];

		return typeof name === 'string' ? super.transform(`ArtTreatments.ART.${name}`, ...args) : '';
	}
}
